export default [{
    path: '/my/address',
    name: 'address',
    component: () => import('@/projects/my/address'),
    meta: {
        title: '地址管理',
        index: 1,
    }
},
{
    path: '/my/addAddress',
    name: 'addAddress',
    component: () => import('@/projects/my/addAddress'),
    meta: {
        title: '新增地址',
        index: 2,
    }
},
{
    path: '/my/follow',
    name: 'follow',
    component: () => import('@/projects/my/follow'),
    meta: {
        title: '关注商家',
        index: 1,
    }
},
{
    path: '/my/info',
    name: 'info',
    component: () => import('@/projects/my/info'),
    meta: {
        title: '基本资料',
        index: 1,
    }
},
// {
//     path: '/my/storeMsg',
//     name: 'storeMsg',
//     component: () => import('@/projects/my/storeMsg'),
//     meta: {
//         title: '商家账号',
//         index: 1,
//     }
// },
{
    path: '/my/intro',
    name: 'intro',
    component: () => import('@/projects/my/intro'),
    meta: {
        title: '公司简介',
        index: 1,
    }
},
{
    path: '/my/baoxianinfo',
    name: 'baoxianinfo',
    component: () => import('@/projects/my/baoxianinfo'),
    meta: {
        title: '投保步骤',
        index: 1,
    }
},
{
    path: '/my/about',
    name: 'about',
    component: () => import('@/projects/my/about'),
    meta: {
        title: '关于我们',
        index: 1,
    }
},
{
    path: '/my/bodyData',
    name: 'bodyData',
    component: () => import('@/projects/my/bodyData'),
    meta: {
        title: '身体数据',
        index: 1,
    }
},
{
    path: '/my/bodyDataOld',
    name: 'bodyData',
    component: () => import('@/projects/my/bodyData_old.vue'),
    meta: {
        title: '身体数据TEST',
        index: 1,
    }
},
{
    path: '/my/wallet',
    name: 'wallet',
    component: () => import('@/projects/my/wallet'),
    meta: {
        title: '我的钱包',
        index: 1,
    }
},
{
    path: '/my/match',
    name: 'match',
    component: () => import('@/projects/my/match'),
    meta: {
        title: '我的赛事',
        index: 1,
    }
},
{
    path: '/my/video',
    name: 'video',
    component: () => import('@/projects/my/video'),
    meta: {
        title: '视频',
        index: 1,
    }
},
{
    path: '/my/privacy',
    name: 'privacy',
    component: () => import('@/projects/my/privacy'),
    meta: {
        title: '',
        index: 1,
    }

},
{
    path: '/my/routeCollection',
    name: 'routeCollection',
    component: () => import('@/projects/my/routeCollection'),
    meta: {
        title: '我的收藏',
        index: 1,
    }

},
{
    path: '/my/shareRecords',
    name: 'shareRecords',
    component: () => import('@/projects/my/shareRecords'),
    meta: {
        title: '分享记录',
        index: 1,
    }

},
{
    path: '/my/shareDetail',
    name: 'shareDetail',
    component: () => import('@/projects/my/shareDetail'),
    meta: {
        title: '分享详情',
        index: 1,
        param: "Id=分享记录ID"
    }

},
{
    path: '/my/emergencyContact',
    name: 'emergencyContact',
    component: () => import('@/projects/my/emergencyContact'),
    meta: {
        title: '紧急联系人',
        index: 1,
    }

},

{
    path: '/my/cyclingRecord',
    name: 'cyclingRecord',
    component: () => import('@/projects/my/cyclingRecord'),
    meta: {
        title: '骑行记录',
        index: 1,
        param: "id=轨迹ID"
    }

},
{
    path: '/my/cyclingRecordDetails',
    name: 'cyclingRecordDetails',
    component: () => import('@/projects/my/cyclingRecordDetails'),
    meta: {
        title: '骑行记录详情',
        index: 1,
        param: "id=轨迹ID"
    }
},
{
    path: '/my/cyclingRecordLab',
    name: 'cyclingRecordLab',
    component: () => import('@/projects/my/cyclingRecordLab'),
    meta: {
        title: '骑行记录记圈',
        index: 1,
        param: "id=轨迹ID"
    }
},
{
    path: '/my/cyclingRecordChart',
    name: 'cyclingRecordChart',
    component: () => import('@/projects/my/cyclingRecordChart'),
    meta: {
        title: '骑行记录图表',
        index: 1,
        param: "id=轨迹ID"
    }
},
{
    path: '/my/ranking',
    name: 'ranking',
    component: () => import('@/projects/my/ranking'),
    meta: {
        title: '里程排行榜',
        index: 1,
    }

},
{
    path: '/my/monthTeam',
    name: 'monthTeam',
    component: () => import('@/projects/my/monthTeam'),
    meta: {
        title: '团体',
        index: 2,
    }
},
{
    path: '/my/teamRanking',
    name: 'teamRanking',
    component: () => import('@/projects/my/teamRanking'),
    meta: {
        title: '队伍里程贡献榜',
        index: 3,
        param: 'teamId=团体ID&teamName=团体名称&year=年份&month=月份'
    }
},
{
    path: '/my/device',
    name: 'device',
    component: () => import('@/projects/my/device'),
    meta: {
        title: '我的设备',
        index: 1,
    }

},
{
    path: '/my/addCar',
    name: 'addCar',
    component: () => import('@/projects/my/addCar'),
    meta: {
        title: '我的爱车',
        index: 1,
    }

},
{
    path: '/my/maintenance',
    name: 'maintenance',
    component: () => import('@/projects/my/maintenance'),
    meta: {
        title: '维修保养',
        index: 1,
    }

},
{
    path: '/my/feedback',
    name: 'feedback',
    component: () => import('@/projects/my/feedback'),
    meta: {
        title: '意见反馈',
        index: 1,
    }
},
{
    path: '/my/download',
    name: 'download',
    component: () => import('@/projects/my/download'),
    meta: {
        title: '下载APP',
        index: 1,
    }

},
{
    path: '/my/stageScore',
    name: 'stageScore',
    component: () => import('@/projects/my/stageScore'),
    meta: {
        title: '你的成绩',
        index: 1,
        param: "Id=赛段ID"
    }

},
{
    path: '/my/stageRanking',
    name: 'stageRanking',
    component: () => import('@/projects/my/stageRanking'),
    meta: {
        title: '排行榜',
        index: 1,
        param: "Id=赛段ID"
    }
}
]



// WEBPACK FOOTER //
// ./src/projects/my/index.js